import * as React from "react";
import get from "lodash/get";
import "./Image.css";
import { isEditMode } from "../../utils/sendClickToMerchant";
import { interpolate } from "../../utils/string";
import { extractInfluencerAndAdvocate } from "../../utils/share";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

import { openNewWindowActions } from "../../constants";

export interface ImageProps extends ComponentBaseProps {
  action: string;
  center: string;
  classNames: string;
  height: number;
  label: string;
  mode: string;
  onClick: () => void;
  repeat: string;
  src: string;
  style: { [styleProp: string]: string };
  width: number;
}

// tslint:disable-next-line:no-any
export class Image extends ComponentBase<ImageProps> {
  render() {
    const {
      action,
      classNames,
      data,
      src,
      mode,
      height,
      width,
      children,
      referral,
      share,
      repeat,
      center,
      label = "image",
      config,
    } = this.props;
    const defaultToBlank = !isEditMode();
    const configShareData = get(config, ["data", "share"], {});
    const { advocate, influencer } = extractInfluencerAndAdvocate(
      configShareData,
      referral
    );
    const allData = { ...data, referral, share, advocate, influencer };
    const interpolatedSrc = interpolate(src, allData, defaultToBlank);
    const actionOpensWindow = openNewWindowActions.includes(
      get(action, "name", "")
    );

    const style = {
      backgroundPosition: center ? "center" : undefined,
      backgroundRepeat: repeat ? undefined : "no-repeat",
      cursor: action ? "pointer" : undefined,
      height,
      width,
      ...this.props.style,
      backgroundImage: `url("${interpolatedSrc}")`,
    };

    const sharingProps = actionOpensWindow
      ? {
          rel: "noopener",
          tabIndex: 0,
        }
      : {};

    const title = actionOpensWindow
      ? `${label} (opens in a new window)`
      : label;

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        // onMouseDown={this.onMouseDown}
        onAnimationEnd={this.resetAnimation}
        style={style}
        title={title}
        aria-hidden={action ? "false" : "true"}
        className={`Image-image Image-mode-${mode || "default"} ${
          classNames || ""
        } ${this.state.animationClass}`}
        // onClick={this.onClick}
        role="img"
        ref={(component) => (this.component = component)}
        {...sharingProps}
      >
        {children}
        <span className="screen-reader-only">{label}</span>
      </div>
    );
  }
}
